export const itemsButtonsCtasTablet = [
	{
		id: 'tablet-experimentar-astrea',
		type: 'btn',
		title: 'Experimentar o Astrea grátis',
		link: '/experimente-o-astrea/',
		btnClass: 'astrea-btn',
		showOn: ['home', 'aurum', 'astrea', 'subPage'],
	},
	{
		id: 'tablet-agendar-themis-ea',
		type: 'btn',
		title: 'Agendar uma demonstração',
		link: '/experimente-o-themis-ea/',
		btnClass: 'themis-btn',
		showOn: ['themisEA'],
	},
	{
		id: 'tablet-agendar-themis-dj',
		type: 'btn',
		title: 'Agendar uma demonstração',
		link: '/experimente-o-themis-dj/',
		btnClass: 'themis-btn',
		showOn: ['themisDJ', 'themisCalculator'],
	},
]
